import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";

export default function CustomAlertDialog({ isOpen, onClose, onCancel, onSubmit, title, message, submitBtnName = "Submit", cancelBtnName  = "Cancel"}) {
    return (
        <React.Fragment>
            <Dialog
                open={isOpen}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                       {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="error" sx={{ borderRadius: '5px' }} variant="outlined" onClick={onCancel}>{cancelBtnName}</Button>
                    <Button variant="contained" sx={{
                        backgroundColor:'var(--hoverColorBold)',
                        ':hover':{
                            backgroundColor: 'var(--hoverColorBold)',
                        },
                        color:'black',
                        borderRadius:'5px'
                    }} onClick={onSubmit} autoFocus>
                        {submitBtnName}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
  }